"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _imeiReceive = require("@/api/imei-receive");
var _ReceiveImeiDetailModal = _interopRequireDefault(require("./ReceiveImeiDetailModal.vue"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _moment = _interopRequireDefault(require("moment"));
var _UpdateRmaNumberModal = _interopRequireDefault(require("./UpdateRmaNumberModal.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ReceiveImeiDetailModal: _ReceiveImeiDetailModal.default,
    Pagination: _Pagination.default,
    UpdateRmaNumberModal: _UpdateRmaNumberModal.default
  },
  data: function data() {
    return {
      data: [],
      query: {
        page: 1,
        limit: 10,
        search: ""
      },
      date: [(0, _moment.default)().subtract(7, "days").toDate(), (0, _moment.default)().toDate()],
      total: 0,
      loading: false
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    handleUpdateRmaNumber: function handleUpdateRmaNumber(row) {
      this.$refs.UpdateRmaNumberModal.handleOpen(row.id);
    },
    viewDetail: function viewDetail(row) {
      this.$refs.ReceiveImeiDetailModal.handleOpen(row.id);
    },
    fetchData: function fetchData() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this.loading = true;
              _context.next = 4;
              return _imeiReceive.imeiReceiveApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.query), {}, {
                from: (0, _moment.default)(_this.date[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                to: (0, _moment.default)(_this.date[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss")
              }));
            case 4:
              res = _context.sent;
              _this.data = res.data.data;
              _this.total = res.data.total;
            case 7:
              _context.prev = 7;
              _this.loading = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0,, 7, 10]]);
      }))();
    }
  }
};